var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Modal } from "react-bootstrap/lib";
import Flex from "@irati/ui/src/Flex";
import CloseBase from "@irati/ui/src/Close";
var MODAL_HEADER_DISTANCE_FROM_TOP = 60;
var SMALL_MODAL_SIZE = 480;
export var StandardModal = styled(Modal)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  .modal-content{\n    border-radius: ", ";\n    border-color: transparent;\n    box-shadow: ", ";\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  .modal-content{\n    border-radius: ", ";\n    border-color: transparent;\n    box-shadow: ", ";\n  }\n  ",
    "\n  ",
    "\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.high;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.maxWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex !important;\n    .modal-dialog{\n      margin: auto;\n      width: 100%;\n    }\n  "], ["\n    display: flex !important;\n    .modal-dialog{\n      margin: auto;\n      width: 100%;\n    }\n  "])));
}, function (_a) {
    var small = _a.small, theme = _a.theme;
    return small && theme.mediaQueries.minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .modal-dialog{\n      width: ", "px;\n    }\n  "], ["\n    .modal-dialog{\n      width: ", "px;\n    }\n  "])), SMALL_MODAL_SIZE);
}, function (_a) {
    var customWidth = _a.customWidth, theme = _a.theme;
    return customWidth && theme.mediaQueries.minWidthMedia.tablet(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    .modal-dialog{\n      width: ", "px;\n    }\n  "], ["\n    .modal-dialog{\n      width: ", "px;\n    }\n  "])), customWidth);
}, function (_a) {
    var mobileFullHeight = _a.mobileFullHeight, image = _a.image, theme = _a.theme;
    return mobileFullHeight && theme.mediaQueries.maxWidthMedia.tablet(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    .modal-dialog{\n      height: 100%;\n    }\n    .modal-content{\n      display: flex;\n      min-height: ", ";\n    }\n  "], ["\n    .modal-dialog{\n      height: 100%;\n    }\n    .modal-content{\n      display: flex;\n      min-height: ",
        ";\n    }\n  "])), image
        ? "calc(100% - " + MODAL_HEADER_DISTANCE_FROM_TOP + "px)"
        : "100%");
});
export var ImageModal = styled(StandardModal)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  .modal-content{\n    margin-top: ", "px;\n  }\n"], ["\n  .modal-content{\n    margin-top: ", "px;\n  }\n"])), MODAL_HEADER_DISTANCE_FROM_TOP);
export var Buttons = styled(Flex)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.maxWidthMedia.tablet(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    align-items: center;\n    flex-direction: column-reverse;\n    justify-content: space-between;\n    height: ", ";\n  "], ["\n    align-items: center;\n    flex-direction: column-reverse;\n    justify-content: space-between;\n    height: ", ";\n  "])), theme.spacing.ten);
});
export var Close = styled(CloseBase)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  top: ", ";\n  right: ", ";\n  ", "\n"], ["\n  top: ", ";\n  right: ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.two;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    top: ", ";\n    right: ", ";\n  "], ["\n    top: ", ";\n    right: ", ";\n  "])), theme.spacing.three, theme.spacing.three);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
